import {Task} from './Task.js';
import {isNil, notNil} from './utils.js';

/**
 * Checks the document URL for required query-string params, and for each found, executes the supplied
 * function with the param's name and value.
 *
 * Example:
 * let requiredParamsMap = new Map();
 * requiredParamsMap.set('m', (name, value) => {
 *   App.globals.dataStore.globals.mToken = value;
 * });
 * requiredParamsMap.set('env', (name, value) => {
 *   App.globals.dataStore.environment = value;
 *    });
 *
 * let paramsTask = new GetRequiredURLParamsTask(requiredParamsMap);
 * paramsTask.start();
 *
 */
export class GetRequiredURLParamsTask extends Task {

  /**
   * @param paramsMap A Map of parameter names and corresponding functions to call if the parameter in question
   * is found. If a given param is found, the function is invoked with the value of that param.
   * To take no action for a given param, pass no value or null as the funtion to execute.
   */
  constructor (paramsMap) {
    super();
    this.name = "GET_REQUIRED_URL_PARAMS";
    this.paramsMap = paramsMap;
  }

  start () {
    super.start();
    // URLSearchParams docs: https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    let urlParams = new URLSearchParams(window.location.search);
    let missingParams = [];
    this.paramsMap.forEach((paramFunc, paramName) => {
      if (isNil(urlParams.get(paramName))) {
        missingParams.push(paramName);
      }
    });

    if (missingParams.length === 0) {
      this.paramsMap.forEach((paramFunc, paramName) => {
        if (notNil(paramFunc)) {
          // Invoke the supplied function for each parameter
          paramFunc(paramName, urlParams.get(paramName));
        }
      });
      this.done();
    } else {
      this.fail(new Error(`Missing query-string parameter(s) [${missingParams.join(', ')}] on URL: ${window.location}`));
    }
  }
}


